// FishManager ------------------------------------------------
function FishManager() {

	//Import classes
	var Container = include('createjs.Container'),
		Fish = include('WGBH.Fish');
	
	// objects
	this.view = new Container();
	this.fishes = [];	
	
	// used to initialize the fidgineera
	this.init = function() {
		var ctr = 0,
			ofs = app.config.GAME.FISH.seq.ofs,
			max = this.fishes.length,
			sr_cont = '<h3>Fish Sequence</h3>';
						
		// add fish to the display
		sr_cont += '<ul>';
		for(; ctr < max; ++ctr) {
			this.fishobj = new Fish(this.fishes[ctr].clr, app.config.GAME.FISH.delays[ctr], false);
			this.fishobj.view.x = ofs * ctr;
			this.fishobj.view.y = 0;
			this.view.addChild(this.fishobj.view);
			this.fishes[ctr].obj = this.fishobj;
			sr_cont += '<li>'+app.config.GAME.LABELS[this.fishes[ctr].clr]+' fish</li>';
		}
		sr_cont += '</ul>';
		app.acc_mgr.setSRContent(sr_cont);
		// add answer fish for fade in
		this.ans_fish = new Fish('red', 0, true);
		this.ans_fish.view.x = this.fishes[7].obj.view.x;
		this.ans_fish.view.y = this.fishes[7].obj.view.y;
		this.ans_fish.hideFish();
		this.view.addChild(this.ans_fish.view);
		this.view.x = app.config.GAME.FISH.seq.x;
		this.view.y = app.config.GAME.FISH.seq.y;
	};

	// used to display the answer
	this.displayAnswer = function(clr) {
		// stop animation of the white fish
		this.fishes[7].obj.stopFishAnimation();
		this.ans_fish.fadeInFish(clr);
	};
	
	// used to reset the selections
	this.resetAnswer = function() {
		this.fishes[7].obj.startAnimation();
		this.ans_fish.hideFish();
	};

	// used to clear the object
	this.clearObject = function() {
		while(this.view.numChildren > 0) {
			this.view.removeChildAt(0);
		}
		// clear the fish
		while(this.fishes.length > 0) {
			this.fishobj = this.fishes[0].obj;
			this.fishobj.clearObject();
			this.fishes.shift();
			this.fishobj = null;
		}	
		this.fishes = null;
		this.view = null;	
	};

}

namespace('WGBH').FishManager = FishManager;
